import { formatFullName } from "helper/personName";
import { INVITED_PROFILE_TYPE } from "pages/createMission/utils/invitedProfiles";

// French numbers (Martinique, Guadeloupe, mainland) read best in their national form.
const NATIONAL_PREFIXES = ["+596", "+590", "+33"];

/** "+596696451278" → "0696 45 12 78"; other countries stay international. */
export const formatPoolPhone = (phone) => {
    if (!phone) return "";
    const compact = String(phone).replace(/\s+/g, "");
    const prefix = NATIONAL_PREFIXES.find((item) => compact.startsWith(item));
    const subscriber = prefix ? compact.slice(prefix.length) : "";
    if (!prefix || !/^\d{9}$/.test(subscriber)) return compact;
    const national = `0${subscriber}`;
    return [national.slice(0, 4), national.slice(4, 6), national.slice(6, 8), national.slice(8, 10)].join(" ");
};

/** "2 oct. 2026" */
export const formatPoolDate = (date) => {
    const parsed = new Date(date);
    if (!date || Number.isNaN(parsed.getTime())) return "";
    return new Intl.DateTimeFormat("fr-FR", {
        day: "numeric",
        month: "short",
        year: "numeric",
        timeZone: "Europe/Paris",
    }).format(parsed);
};

export const formatPoolMemberName = (member) =>
    formatFullName(member?.firstname, member?.lastname);

/**
 * "0696 45 12 78 · ajouté le 2 oct. 2026", the history with the company replacing the date once
 * there is one, and "· Inscription en cours" while the member has no Jobbiz account.
 */
export const formatPoolMemberDetail = (member, language) => {
    const label = (key, defaultValue) => language.getValue(`privatePool.member.${key}`, defaultValue);
    const contact = member?.phone ? formatPoolPhone(member.phone) : member?.email || "";
    const missionsCount = Number(member?.missionsWithCompany) || 0;
    const addedOn = formatPoolDate(member?.createdAt);
    let history = "";
    if (missionsCount === 1) {
        history = label("oneMission", "1 mission avec vous");
    } else if (missionsCount > 1) {
        history = label("manyMissions", "{count} missions avec vous").replace("{count}", missionsCount);
    } else if (addedOn) {
        history = label("addedOn", "ajouté le {date}").replace("{date}", addedOn);
    }
    const parts = [contact, history].filter(Boolean);
    if (member?.status === "pending") parts.push(label("pending", "Inscription en cours"));
    return parts.join(" · ");
};

/** Entry of `data.invitedProfiles` for a private pool member. */
export const toPrivatePoolProfile = (member, language) => ({
    type: INVITED_PROFILE_TYPE.PRIVATE_POOL,
    id: member._id,
    name: formatPoolMemberName(member),
    detail: formatPoolMemberDetail(member, language),
});
